/**
 * Konfiguration für das Solarenergie-System.
 * Bestimmt wie viel Energie Planeten von ihrer Sonne erhalten,
 * abhängig von Distanz (orbital_ring) und Sonnenalter.
 */

export interface SolarEnergyConfig {
  /** Basis-Energiewert bei Luminosity 1.0, Ring 2, junger Sonne. */
  readonly baseEnergy: number;
  /** Distanz-Faktor pro orbital_ring (Index = Ring). */
  readonly distanceFactors: readonly number[];
  /** Energie-Boost pro Altersstufe (0.05 = +5%). */
  readonly ageBoostPerStep: number;
  /** Anzahl Altersstufen (10 = je 10% Lebensdauer). */
  readonly ageSteps: number;
}

export function defaultSolarEnergyConfig(): SolarEnergyConfig {
  return {
    baseEnergy: 100,
    //                  Ring: 0  1   2     3     4    5    6    7
    distanceFactors: [0, 0, 1.0, 0.95, 0.85, 0.8, 0.7, 0.6],
    ageBoostPerStep: 0.05,
    ageSteps: 10,
  };
}
